export const EUnitMeasureSystem = {
  METRIC: "METRIC",
  IMPERIAL: "IMPERIAL",
};

export const EUnitMeasureSystemAreaUnit = {
  METRIC: "ha",
  IMPERIAL: "ac",
};
